import { render, staticRenderFns } from "./organization-policy-form.vue?vue&type=template&id=29c929c6"
import script from "./organization-policy-form.vue?vue&type=script&lang=js"
export * from "./organization-policy-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports